import { DefaultMarkerIcon } from "@App/Components/atoms/map/markerIcons/DefaultMarkerIcon";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * The default configuration, used as a fallback and base for all other configurations.
 * Modify this config to change default values for all whitelabels.
 */
export const config: Config = {
  slug: "repareo",
  internationalNumberPlate: false,
  pagination: {
    maxVisibleItems: 6,
  },
  navbar: {
    logos: {
      right: {
        component: <RepareoLogo />,
      },
    },
  },
  reviews: {
    show: true,
  },
  legal: {
    privacyPolicyUrl: "https://www.repareo.de/datenschutzerklaerung/",
  },
  checkout: {
    vin: {
      display: false,
    },
    claimNumber: {
      display: () => false,
      required: () => false,
    },
    contractNumber: {
      display: false,
    },
    optIns: {
      reviewOptIn: {
        show: false,
      },
    },
  },
  garageList: {
    maxRecommendedGarages: 20,
    itemsPerPage: 100,
  },
  map: {
    MarkerIcon: DefaultMarkerIcon,
    markerContent: "distance",
  },
  wording: {
    services: {
      label: {
        useServiceName: true,
        usePremiumServiceNames: false,
      },
    },
  },
};

export default config;
